import { render, staticRenderFns } from "./FeaturedUsersWarning.vue?vue&type=template&id=6bd8bd81&scoped=true"
import script from "./FeaturedUsersWarning.vue?vue&type=script&lang=ts"
export * from "./FeaturedUsersWarning.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedUsersWarning.vue?vue&type=style&index=0&id=6bd8bd81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8bd81",
  null
  
)

export default component.exports